import podscribePixelStr from './cookie-trackers/landing/podscribe-pixel.js?raw';
import quoraPixelStr from './cookie-trackers/landing/quora-pixel.js?raw';
import taboolaPixelStr from './cookie-trackers/landing/taboola-pixel.js?raw';
import { tiktokPixelScript } from './cookie-trackers/landing/tiktok-pixel';
import twitterTrackingStr from './cookie-trackers/landing/twitter-tracking.js?raw';
import { type CookieTrackers, strToInlineScript } from './seo';
import { shouldDisableTrackers } from './tracker-suppression';

export function cookieTrackersLanding(): CookieTrackers {
  if (shouldDisableTrackers()) return [];

  return [
    tiktokPixel(),
    quoraPixel(),
    podscribePixel(),
    twitterTracking(),
    taboolaPixel(),
    ahrefAnalytics(),
  ].flat();
}

// Landing trackers must never assert a price. The price is
// arm-dependent (the pricing test runs $39/$59/$79 × trial/no-trial),
// while these pages are anonymous — served before the visitor is
// bucketed — and shared-cached at the CDN, so one document is reused
// across every arm. Any amount baked in here is wrong for most
// viewers and unfixable at this layer. A ViewContent is a content
// view, not a valued conversion; revenue is asserted once, at
// /post-purchase, from the Stripe-resolved charge.
function tiktokPixel(): CookieTrackers {
  return [strToInlineScript(tiktokPixelScript)];
}

function quoraPixel(): CookieTrackers {
  return [strToInlineScript(quoraPixelStr)];
}

function podscribePixel(): CookieTrackers {
  return [strToInlineScript(podscribePixelStr)];
}

function twitterTracking(): CookieTrackers {
  return [strToInlineScript(twitterTrackingStr)];
}

function taboolaPixel(): CookieTrackers {
  return [strToInlineScript(taboolaPixelStr)];
}

function ahrefAnalytics(): CookieTrackers {
  return [
    {
      src: 'https://analytics.ahrefs.com/analytics.js',
      'data-key': 'IpFJQjmvA32U9LJhL+NZUw',
      async: true,
    } as React.ScriptHTMLAttributes<HTMLScriptElement>,
  ];
}
